import http from 'services/utils/http';
import { subscribeToAngularEvent } from 'services/utils/angularUtils';

const maxCacheMinutes = 60;
const maxCacheNumber = 6;

export default {
    namespaced: true,
    state: {
        data: {}
    },
    mutations: {
        set(state, { api, req, data }) {
            if (!state.data[api]) {
                state.data[api] = {};
            }
            const apiCacheKeys = Object.keys(state.data[api]);
            if (apiCacheKeys.includes(req)) {
                delete state.data[api][req];
            } else if (apiCacheKeys.length > maxCacheNumber) {
                delete state.data[api][apiCacheKeys[0]];
            }

            state.data[api][req] = {
                raw: data,
                // caching time, in order to make sure the cache is saved for max maxCacheMinutes mins
                timeStamp: new Date()
            };
        },
        clearCache: (state, { api }) => {
            state.data[api] = {};
        }
    },
    actions: {
        async getWithCache({ getters, commit }, {
            api,
            req = '',
            refresh = false,
            needToken = true,
            ttl,
            cancelToken
        }) {
            let response = getters.getFromCache(api, req, { ttl });

            if (!response || refresh) {
                response = await http.get(req, needToken, { cancelToken });
                commit('set', { api, req, data: response });
            }

            return response;
        }
    },
    getters: {
        getFromCache: (state) => (api, req = '', { ttl = maxCacheMinutes } = {}) => {
            const apiCache = state.data[api];
            const cacheExists = !!apiCache?.[req]?.raw;
            const isExpired = ttl && (
                !apiCache
                || !apiCache[req]
                || !apiCache[req].timeStamp
                || (apiCache[req].timeStamp.getTime()
                    + (ttl) * 60 * 1000) < new Date().getTime()
            );
            if (!isExpired && cacheExists) {
                return state.data[api][req].raw;
            }
            return null;
        }
    }
};

/**
 * Initialize the cache state event subscriptions
 * @param {import('vuex').Store} store
 */
export const cacheStateInit = (store) => {
    subscribeToAngularEvent('clearCache', (e, api) => {
        store.commit('cache/clearCache', { api });
    });
};
